import { render, staticRenderFns } from "./PotatoSampleFormGroup.vue?vue&type=template&id=2f784f7b"
import script from "./PotatoSampleFormGroup.vue?vue&type=script&lang=js"
export * from "./PotatoSampleFormGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports